// eslint-disable-next-line import/prefer-default-export
export const GetBrandVisibilitySelector = ({
  brandVisibility: { GetBrandVisibility }
}) => GetBrandVisibility;

export const PostBrandVisibilitySelector = ({
  brandVisibility: { PostBrandVisibility }
}) => PostBrandVisibility;
